import React from "react";
import { STAT_LABELS } from "../../data/classes";

const STAT_ICONS = {
  pv: "❤️",
  atk: "⚔️",
  def: "🛡️",
  vit: "💨",
  crit: "💥",
  degatsCrit: "🌟",
  degatsElem: "🔥",
  res: "✨",
  precision: "🎯",
};

const STAT_COLORS = {
  pv: "bg-rose-500",
  atk: "bg-orange-500",
  def: "bg-blue-500",
  vit: "bg-emerald-500",
  crit: "bg-pink-500",
  degatsCrit: "bg-yellow-500",
  degatsElem: "bg-purple-500",
  res: "bg-cyan-500",
  precision: "bg-indigo-500",
};

export const StatsGrid = ({ stats, compact = false, "data-testid": testId }) => {
  const keys = ["pv", "atk", "def", "vit", "crit", "degatsCrit", "degatsElem", "res", "precision"];
  return (
    <div data-testid={testId} className={`grid ${compact ? "grid-cols-3 gap-1.5" : "grid-cols-3 gap-2"}`}>
      {keys.map((k) => {
        const val = k === "pv" ? `${stats.pv}/${stats.pvMax}` : stats[k];
        const suffix = (k === "crit" || k === "precision") ? "%" : "";
        return (
          <div
            key={k}
            data-testid={`stat-${k}`}
            className={`${STAT_COLORS[k]} border-2 border-slate-950 rounded-lg ${compact ? "px-2 py-1" : "px-2.5 py-1.5"} flex items-center justify-between cartoon-shadow-static`}
          >
            <span className="text-sm">{STAT_ICONS[k]}</span>
            <span className={`font-bold text-slate-950 ${compact ? "text-xs" : "text-sm"}`}>{val}{suffix}</span>
          </div>
        );
      })}
    </div>
  );
};

export const StatLine = ({ statKey, value, max }) => (
  <div className="flex items-center gap-2 text-sm">
    <span>{STAT_ICONS[statKey]}</span>
    <span className="font-bold uppercase text-xs tracking-wider text-slate-300">{STAT_LABELS[statKey]}</span>
    <span className="ml-auto font-bold">{max ? `${value}/${max}` : value}</span>
  </div>
);

export const HealthBar = ({ current, max, label = "PV", className = "", testId, showText = true, colorByHealth = false }) => {
  const pct = Math.max(0, Math.min(100, (current / max) * 100));
  const fill = colorByHealth
    ? pct > 50
      ? "from-emerald-500 to-emerald-400"
      : pct > 25
        ? "from-amber-500 to-yellow-400"
        : "from-rose-600 to-rose-500"
    : "from-rose-600 to-rose-400";
  return (
    <div data-testid={testId} className={`relative ${className}`}>
      <div className={`${showText ? "h-6" : "h-3.5"} bg-slate-950 border-[3px] border-slate-950 rounded-full overflow-hidden cartoon-shadow-static`}>
        <div
          className={`h-full bg-gradient-to-r ${fill} transition-all duration-500`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showText && (
        <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-white drop-shadow-[1px_1px_0_rgba(0,0,0,1)]">
          {label}: {Math.round(current)}/{max}
        </div>
      )}
    </div>
  );
};
